import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogRef } from '@ngneat/dialog';
import { CrmSurveysComposition } from '@shared/compositions/crm-surveys.composition';
import { AlertMessageComponent, ButtonComponent, IconComponent } from '@shared/components/ui';
import { TranslateModule } from '@ngx-translate/core';
import { HumanizePipe, TruncateTextPipe } from '@shared/pipes';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AlertType } from '@core/enums';
import { CrmSurveyAnswerOptionEntity } from '@core/entities';
import { TippyModule } from '@ngneat/helipopper';
import { GetUserId } from '@core/utils';

@Component({
  selector: 'app-crm-survey-details',
  imports: [CommonModule, ButtonComponent, IconComponent, TranslateModule, TruncateTextPipe, NgxSkeletonLoaderModule, AlertMessageComponent, HumanizePipe, TippyModule],
  templateUrl: './crm-survey-details.component.html',
  styleUrls: ['./crm-survey-details.component.scss'],
})
export class CrmSurveyDetailsComponent extends CrmSurveysComposition implements OnInit {
  protected readonly AlertType = AlertType;
  private readonly _dialogRef = inject(DialogRef);

  get isUserVoted(): boolean {
    return this.currentSurvey.votes.some((vote) => vote.tineonUserId === +GetUserId());
  }

  ngOnInit() {
    const surveyId = this._dialogRef.data.surveyId;
    if (surveyId) {
      this._fetchSurveyDetails(surveyId);
    }
  }

  getAnswerRatioPercentage(answerOption: CrmSurveyAnswerOptionEntity): number {
    const totalVotes = this.currentSurvey.surveyAnswerOptions.reduce((total, option) => {
      return total + option.votedUsersCount || 0;
    }, 0);

    const answerVotes = answerOption.votedUsersCount;
    if (totalVotes === 0 || !answerVotes) {
      return 0;
    }

    return (answerVotes / totalVotes) * 100 || 0;
  }

  closeDialog(data?: any) {
    this._dialogRef.close(data);
  }
}
